/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Timestamp/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Timestamp({
  children,
  viewPath = "/DesignSystem/VerticalTimeline/VerticalTimelineForm/Timestamp"
  
}) {
let timelineEventTimestampValueData = fromData.useDataFormat({ viewPath,
context: 'timeline_event',
path: 'timestamp',
format: fromHelpers.formatDateTime,
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Timestamp.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 color={dtColorsNeutral900}
 data="timeline_event.timestamp"
 format="helpers.js formatDateTime"
 text={timelineEventTimestampValueData}
/>
</div>
{children}
</React.Fragment>)
}